import React, { useEffect, useContext } from "react";
import useForm from 'react-hook-form';
import ReactTable from "react-table";
import { useTranslation } from 'react-i18next';

// @material-ui/core components
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import MenuItem from "@material-ui/core/MenuItem";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";

// icons
import AssignmentIcon from '@material-ui/icons/Assignment';
import Search from "@material-ui/icons/Search";

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePutApi } from "beaktShared/services/crudeApiService";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from "beaktShared/helpers/extras";

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function AjusteEstoque() {
    const { t } = useTranslation(); 
    const session = useContext(SessionContext);
    const classes = useStyles();    

    const { register, setValue, errors,  clearError, handleSubmit } = useForm({mode: "onChange"});
   
    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };

    const [alert,setalert] = React.useState();
    const showAlert = (message, tipo) => {        
        setalert(<SweetAlert
          error={tipo=='error'?true:false}
          warning={tipo=='warning'?true:false}
          success={tipo=='success'?true:false}
          title="Aviso"
          onConfirm={() => setalert(null)}
        >  
        <div dangerouslySetInnerHTML={{ __html: message}} /> 
        </SweetAlert> );
    };

    const [loading,setloading] = React.useState(false);
    const [list, setlist] = React.useState([]);
    const loadEstoque = () => {   
        setloading(true);  
        let endPoint = "EstoqueClinica/"+session.estabelecimentoId;        
        UseGetApiSimple(endPoint, 0).then(result => {
            setloading(false);
            if (result.status !== 200) {
                showNotification(result.message, 'error')            
                return false;
            } 
            setlist(result.data);
            return true;
        });
    }

    useEffect(() => {        
        loadEstoque();
    }, []);
    
    const[tipomovimento, settipomovimento] = React.useState("");
    const handleTipoMovimentoChange = event => {
        settipomovimento(event.target.value);
        setValue("tipomovimento", event.target.value);
        if (event.target.value !== "")
          clearError("tipomovimento");
    };

    const [showModal, setshowModal] = React.useState(false);
    const [produtoSelecionado, setprodutoSelecionado] = React.useState({});
    const handleAjustarSaldoClick = (row) => {
        clearError("tipomovimento");
        clearError("qtd");
        clearError("historico");
        settipomovimento("");
        setprodutoSelecionado(row);
        setValue("qtd", "0");
        setValue("historico", "");
        setshowModal(true);
    }

    const [loadingAcoes,setloadingAcoes] = React.useState(false);
    const onSubmit = (data, e) => {        
        e.preventDefault();

        if (tipomovimento === "S" && produtoSelecionado.saldo < data.qtd){
            showAlert(t('error_message.amount_of_information')+"!", "warning");
            return false;
        }

        let dadosput = {            
            estabelecimentoId: session.estabelecimentoId,
            produtoId: produtoSelecionado.produtoId,            
            historico: data.historico,
            entradaSaida: tipomovimento,            
            quantidade: data.qtd,
            usuarioMovimentoId: session.id,
            valorProduto: 0
        }

        setloadingAcoes(true); 
        UsePutApi("EstoqueClinica/AtualizaSaldoProdutoManual", '', dadosput).then(result => {
            setloading(false);
            if (result.status !== 200) {
                showAlert(result.message, "error");
                setloadingAcoes(false); 
                return false;
            }                 
            
            let listatualizada = list.map(l => ((l.produtoId === result.data.produtoId && l.estabelecimentoId === result.data.estabelecimentoId) ? result.data : l));
            
            setlist(listatualizada);
            
            setshowModal(false);
            setloadingAcoes(false); 
            showNotification(t('information_message.successful_adjustment'), 'success');
            return true;
        });
    }

    const columnsProps = [        
        {
            Header: t('label.group'),
            accessor: "grupoDescricao",            
        },
        {
            Header: t('label.product'),
            accessor: "produtoDescricao",            
        },
        {
            Header: t('information_message.current_balance'),
            accessor: "saldo",            
        }        
    ]
    const columnsAcao = [        
    {
        Header: t('label.actions'),
        Cell: row => (
            <div className="actions-right">              
            <Button
                justIcon round simple color="info"
                onClick={() => handleAjustarSaldoClick(row.original)}
            > 
                <Tooltip title={t('label.adjust')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Search />
                </Tooltip>
            </Button>{" "}                          
        </div>
        ),
        sortable: false,
        filterable: false
    }
    ];

    let columns = [...columnsProps,...columnsAcao];    

    return (
        <div className="maxContent">                                     
            {notification.show &&
                <div><br/>
                <SnackbarContent
                    message={notification.message}
                    color={notification.color}
                    closeNotification={() => setNotification({show:false})}
                    close
                />
            </div>}
            <GridContainer>
                {alert}
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <AssignmentIcon />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                {t('sidebar.stock_adjustment')}
                            </h4>
                        </CardHeader>
                        <CardBody>                            
                            <ReactTable
                                loading = {loading}
                                data={list}
                                columns={columns}
                                filterable
                                defaultFilterMethod = {noCaseSensitive}
                                defaultPageSize={10}
                                minRows={5}
                                showPaginationBottom={true}
                                className="-striped -highlight"
                                previousText={t('button.previous')}
                                nextText={t('button.next')}
                                loadingText={t('label.loading')+"..."}
                                noDataText={t('information_message.no_records_found')+"!"}
                                pageText={t('label.page')}
                                ofText={t('label.of')}
                                rowsText={t('label.rows')}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
                
                {loadingAcoes && 
                <div className="carregandoCmp">
                    <div className="box">
                        <label>{t('label.loading')}...</label>
                        <CircularProgress />
                    </div>
                </div> 
                }

                <Dialog
                        classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal }}
                        open={showModal}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => setshowModal(false)}
                        aria-labelledby="classic-modal-slide-title"
                        aria-describedby="classic-modal-slide-description"
                        >               
                    <DialogTitle
                        id="classic-modal-slide-title"
                        disableTypography
                        className={classes.modalHeader}
                        style={{background:'#5c4477'}}
                    >
                        <Button
                            justIcon
                            className={classes.modalCloseButton}
                            key="close"
                            aria-label="Close"
                            color="transparent"
                            onClick={() => setshowModal(false)}
                        >
                            <Close className={classes.modalClose} />
                        </Button>
                        <h4 className={classes.modalTitle} style={{color:'white'}}>{t('information_message.adjust_balance')} </h4>
                    </DialogTitle>
                    <DialogContent id="classic-modal-slide-description" className={classes.modalBody}>                                                   
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <GridContainer>                                            
                                <GridItem xs={12} sm={12} md={12}>
                                    <br/>
                                    <label><b>{t('label.product')+":"}</b> {produtoSelecionado.produto != null && produtoSelecionado.produto.descricao}</label>
                                    <br/><br/>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            error={errors.tipomovimento ? true : false}
                                            select
                                            variant="outlined"              
                                            value={tipomovimento}
                                            onChange={handleTipoMovimentoChange}
                                            label={t('label.movement_type')+" *"}
                                            name="tipomovimento"              
                                            ref={() => register({ name: "tipomovimento" }, { required: true  })}
                                            InputLabelProps={{ shrink: true }}
                                        >
                                        <MenuItem value="E">
                                            {t('label.input')}
                                            </MenuItem>
                                        <MenuItem value="S">
                                            {t('label.output')}
                                            </MenuItem>
                                        </TextField>
                                        <FormHelperText>
                                            {errors.tipomovimento && <span className="obg">{t('label.required')} </span>}
                                        </FormHelperText>
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            error={errors.qtd?true:false}
                                            variant="outlined"
                                            type="number"
                                            inputRef={register({required: t('label.required')})}
                                            label= {t('label.quantity')+" *"}
                                            name="qtd"       
                                            defaultValue="0"                                                                                 
                                            InputLabelProps={{shrink: true}}                                            
                                        />
                                        {errors.qtd && 
                                        <FormHelperText>
                                            <span className="obg"> {errors.qtd.message }</span>
                                        </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <br/>   
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            error={errors.historico?true:false}
                                            variant="outlined"                                        
                                            inputRef={register({required: t('label.required')})}
                                            label={t('label.historic')}
                                            name="historico"                                        
                                            InputLabelProps={{shrink: true}}                                            
                                        />
                                        {errors.historico && 
                                        <FormHelperText>
                                            <span className="obg"> {errors.historico.message }</span>
                                        </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                            </GridContainer>
                            <br/>
                            <center className="no-print">
                                <Button type="submit" color="primary">
                                    {t('label.confirm')}
                                </Button>
                            </center>
                            <br/>
                        </form>
                    </DialogContent>
                </Dialog>

            </GridContainer>                             
        </div>
    );
}